import { Tag } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export const PerformanceReviewUnsolicitedTag = () => {
  const { t } = useTranslation();

  return (
    <Tag appearance="filled" variant="secondary" className="shrink-0">
      {t("performance_review:unsolicited")}
    </Tag>
  );
};
